import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as serviceTypes from '../../../data/booking/constants/service_types';
import AddServiceForm from '../components/AddServiceForm';
import AddBagTransportContainer from '../containers/bag_transport/AddBagTransportContainer';
import AddBikeTransportContainer from '../containers/bike_transport/AddBikeTransportContainer';
import AddRegularShuttleContainer from '../containers/regular_shuttle/AddRegularShuttleContainer';
import AddCarTransportContainer from '../containers/car_transport/AddCarTransportContainer';
import AddCarParkingContainer from '../containers/car_parking/AddCarParkingContainer';
import AddRoadbookMhikesContainer from '../containers/roadbook_mhikes/AddRoadbookMhikesContainer';
import { closeAddService, addService, cancel } from '../../../data/booking/actions/booking';
import { withTranslation} from "react-i18next";
import { startTripEdit } from '../../../data/booking/actions/map';
import {isEmpty} from "lodash";
import {getStage, getHasServices} from '../../../data/booking/selectors/booking';
import AddPeopleTransportContainer from "../containers/people_transport/AddPeopleTransportContainer";
import {getLastHike} from "../../../data/booking/selectors/hike";

class AddServiceFormContainer extends Component {
    static propTypes = {
        serviceAdd: PropTypes.object,
        closeAddService: PropTypes.func,
        cancel: PropTypes.func,
        addService: PropTypes.func,
        showBackButton: PropTypes.bool,
        hasServices: PropTypes.bool,
        startTripEdit: PropTypes.func,
    };

    static defaultProps = {
        showBackButton: true
    };

    handleSelectService(serviceType) {
        this.props.addService(serviceType);
        this.props.startTripEdit()
    }

    handleBack(e) {
        if(this.props.hasServices){
            this.props.cancel();
        } else {
            this.props.closeAddService();
        }
    }

    render() {
        const { serviceAdd, stage, hike } = this.props;

        if (serviceAdd.requestData || stage == 2) {
            switch (serviceAdd.serviceType) {
                case serviceTypes.BAG_TRANSPORT:
                    return <AddBagTransportContainer />;
                case serviceTypes.BIKE_TRANSPORT:
                    return <AddBikeTransportContainer />;
                case serviceTypes.PEOPLE_TRANSPORT:
                    return <AddPeopleTransportContainer />;
                case serviceTypes.REGULAR_SHUTTLE:
                    return <AddRegularShuttleContainer />;
                case serviceTypes.CAR_TRANSPORT:
                    return <AddCarTransportContainer />;
                case serviceTypes.CAR_PARKING:
                    return <AddCarParkingContainer />;
                case serviceTypes.ROADBOOK_MHIKES:
                    return <AddRoadbookMhikesContainer />;
            }
        }

        return (
            <AddServiceForm
                serviceList={serviceTypes.getServiceList().filter((service)=> {
                    return (!isEmpty(serviceAdd.data.route.services) && serviceAdd.data.route.services.includes(service.type))
                     ||  (!isEmpty(hike) && !isEmpty(hike.services) && hike.services.includes(service.type))
                })}
                onSelectService={::this.handleSelectService}
                showBackButton={this.props.showBackButton}
                onBack={::this.handleBack}
            />
        );
    }
}

export default compose(withTranslation(), connect(
    state => ({
        serviceAdd: state.booking.booking.serviceAdd,
        hasServices: !isEmpty(state.booking.booking.entities.services),
        hike: getLastHike(state.booking),
        stage: getStage(state.booking)
    }),
    dispatch => bindActionCreators({ closeAddService, addService, startTripEdit, cancel }, dispatch)
))(AddServiceFormContainer);
